import axios from 'axios'
import wcs from './index'
import { getWishlistNormalized } from '../normalizer'
import { updateCounterWishlist } from '../../libs/utils/counterWishlist'
import qs from 'qs'
import { getCurrentCountry } from '../utils/currentCountry'

export async function wcs_add_wishlist_product({ catentryId }) {
  const { storeId } = wcs.getStoreConfig()
  const newUrl = `/wcs/resources/store/${storeId}/wishlist/sgh/catEntryId/${catentryId}`

  const response = await axios
    .post(newUrl)
    .then(res => res)
    .catch(error => new Error('Failed adding to wishlist', error))
  return response.data
}

export async function wcs_add_wishlist_product_remix({ remixData }) {
  const { storeId } = wcs.getStoreConfig()
  const url = `/wcs/resources/store/${storeId}/remix/add-to-wishes`
  const data = {
    components: buildRemixComponents(remixData),
    language: "en", 
    modelCode: remixData.modelCode,
    modelGrid: remixData.modelGridCode,
    modelMetadata: {
        label: remixData.productDesc,
        sizeDescription: remixData.productSize,
    },
    recipeId: remixData.recipeId,
    upc: remixData.upc,
  }
  return await axios.post(url, data)
    .then(res => res)
    .catch(error => new Error('Failed adding to wishlist', error))
}

export async function wcs_remove_wishlist_product(catentryId) {
  const { storeId } = wcs.getStoreConfig()
  const newUrl = `/wcs/resources/store/${storeId}/wishlist/sgh/catEntryId/${catentryId}`
  const response = await axios
    .delete(newUrl)
    .then(res => res)
    .catch(error => new Error('Failed removing item from wishlist', error))
  return response.data
}

export async function wcs_remove_wishlist_product_remix(recipeId, deleteURI) {
  const { storeId } = wcs.getStoreConfig()
  const newUrl = deleteURI
    ? `/wcs/resources${deleteURI}`
    : `/wcs/resources/store/${storeId}/remix/delete-remix-from-wishlist/configurationId/${recipeId}`
  const response = await axios
    .delete(newUrl)
    .then(res => res)
    .catch(error => new Error('Failed removing item from wishlist', error))
  return response.data
}

export const getWishlistProducts = async (payload = { sortBy: 1 }) => {
  const domain = wcs.getEnvConfig('currentDomain') || ''
  const { storeId, langId } = wcs.getStoreConfig()
  const useMockData = wcs.getEnvConfig('useMockData') || false
  let params = '?'
  params += payload.sortBy ? `orderBy=${payload.sortBy}&` : ''
  params += payload.listId ? `listId=${payload.listId}&` : ''
  params += `_${new Date().getTime()}`
  const getWishlistEndpoint =
    useMockData == 'true'
      ? wcs.getEndPoint('getWishlistProducts')
      : `${domain}/wcs/resources/store/${storeId}/wishlist/sgh/@self${params}&langId=${langId}`
  let response = {}

  try {
    response = await axios.get(getWishlistEndpoint)
    return getWishlistNormalized(response.data)
  } catch (error) {
    console.log(error)
    return error.response
  }
}
export const postEmailSubscription = async parameters => {
  const domain = wcs.getEnvConfig('currentDomain') || ''
  const url = `${domain}/${getCurrentCountry()}/${parameters.brand}/EmailSubscription`
  const params = {
    email: parameters.email,
    optinStatus: parameters.optinStatus || "1"  
  }
  let data = {}
  try {
    data = await axios.post(url, qs.stringify(params))
  } catch (error) {
    data.error = 'Error'
  }
  return data
}

export const postEmailMe = async parameters => {
  const domain = wcs.getEnvConfig('currentDomain') || ''
  const { storeId, langId } = wcs.getStoreConfig()
  const url = `${domain}/wcs/resources/store/${storeId}/emailMe`
  const params = {
    email: parameters.email,
    catEntryId: parameters.catEntryId,
    langId: langId,
  }

  let data = {}

  try {
    data = await axios.post(url, qs.stringify(params))
  } catch (error) {
    /* data.error =
      error.response && error.response.data.errors.length && error.response.data.errors.message
        ? error.response.data.errors.message
        : 'Error' */
    data.error = 'Error'
  }
  return data
}

export const getCounterWishlist = async () => {
  const domain = wcs.getEnvConfig('currentDomain') || ''
  const { storeId, langId } = wcs.getStoreConfig()
  const endpointCounterWishlist = `${domain}/wcs/resources/store/${storeId}/wishlist/sgh/count?time=${new Date().getTime()}&langId=${langId}`

  let countItemWishlist = {}
  await axios.get(endpointCounterWishlist).then(
    response => {
      countItemWishlist = response.data.totalProducts
      updateCounterWishlist(countItemWishlist)
    },
    error => {
      console.log(error)
      countItemWishlist.error =
        error.response &&
        error.response.data.errors.length &&
        error.response.data.errors[0].errorMessage
          ? error.response.data.errors[0].errorMessage
          : 'Error'
    }
  )
  return countItemWishlist
}

export const addToBagCustomized = async (url, params) => {
  const domain = wcs.getEnvConfig('currentDomain') || ''
  const endpoint = `${domain}/wcs/resources${url}`

  let data = {}

  try {
    data = await axios.post(endpoint, params)
  } catch (error) {
    data.error = 'Error'
  }
  return data
}

export const getWishlistProductsCatentryArray = async () => {
  const domain = wcs.getEnvConfig('currentDomain') || ''
  const { storeId } = wcs.getStoreConfig()
  const urlAddr = `${domain}/wcs/resources/store/${storeId}/wishlist/sgh/list`

  try {
    let response = await axios.get(urlAddr)
    return response.data[0].catEntryId
  } catch (error) {
    console.error(error)
    return error.response
  }
}

const parseErpCode = (erpCode = '') => {
  const [code = '', grid = ''] = erpCode.split('_')
  return { code, grid }
}

const COMPONENT_CONFIGS = [
  {
    guard: 'frameComponentCode',
    type: 'frameComponentType',
    erp: 'frontComponentErpCode',
    useErpParse: true,
    meta: {
      componentDescription: 'frontColorDesc',
      colorDescription: 'frontColor',
    },
  },
  {
    guard: 'lensComponentCode',
    type: 'lensComponentType',
    erp: 'lensComponentErpCode',
    useErpParse: true,
    meta: {
      componentDescription: 'lensColorDesc',
      colorDescription: 'lensColor',
      lensStyle: null,
    },
  },
  {
    guard: 'caseComponentCode',
    type: 'caseComponentType',
    erp: 'caseComponentCode',
    useErpParse: false,
    meta: {
      componentDescription: 'caseColorDesc',
      colorDescription: 'caseColor',
      sizeDescription: 'caseSize',
    },
  },
  {
    guard: 'templeCompAnalyticsDetails',
    type: 'templeComponentType',
    erp: 'templeComponentErpCode',
    useErpParse: true,
    meta: {
      componentDescription: 'templeColorDesc',
      colorDescription: 'templeColor',
    },
  },
  {
    guard: 'markupComponentCode',
    type: 'markupComponentType',
    erp: 'markupComponentCode',
    useErpParse: false,
    meta: {
      componentDescription: 'markupColorDesc',
      colorDescription: 'markupColor',
    },
  },
]

export const buildRemixComponents = (remixData) => {
  const attrs = remixData.itemAttributes || {}

  return COMPONENT_CONFIGS
    .filter(({ guard }) => Boolean(attrs[guard]))
    .map(({ type, erp, useErpParse, meta }) => {
      const erpCode = attrs[erp] ?? ''
      const { code, grid } = useErpParse ? parseErpCode(erpCode) : { code: erpCode, grid: '' }
      const componentMetadata = Object.fromEntries(
        Object.entries(meta).map(([key, attrKey]) => [
          key,
          attrKey === null ? null : (attrs[attrKey] ?? null),
        ])
      )

      if (!('sizeDescription' in meta)) {
        componentMetadata.sizeDescription = null
      }

      return {
        componentType: attrs[type],
        erpCode,
        componentCode: code,
        componentGrid: grid,
        upc: '',
        vendorId: erpCode,
        componentMetadata,
      }
    })
}
